module.exports = __webpack_public_path__ + "img/stamp-cooking.a3749d65.png";